import Vue from 'vue';
import Router from 'vue-router';
import login from '@/pages/login';
import index from '@/pages/index';
import register from '@/pages/register';
import orders from '@/pages/index/orders';
import mylist from '@/pages/index/mylist';
import mylistDetail from '@/pages/index/detail';
import complete from '@/pages/index/complete';
import mobileOrdersSender from '@/pages/index/mobile_orders';

import admin from '@/pages/admin';
import adminLogin from '@/pages/admin/login';
import adminOrder from '@/pages/admin/order';
import adminOrderDetail from '@/pages/admin/order_detail';
import adminMember from '@/pages/admin/member';
import adminMemberDetail from '@/pages/admin/member_detail';
import adminDrug from '@/pages/admin/drug';
import adminDrugAdd from '@/pages/admin/drug_add';
import adminRecipe from '@/pages/admin/recipe';
import adminRecipeManager from '@/pages/admin/recipe_manager';

Vue.use(Router);

export default function (store, http) {
  const checkToken = async function beforeEnter(to, from, next) {
    if (!localStorage.token) {
      if (to.fullPath === '/login') return next();
      return next({ path: '/login', replace: true });
    }
    if (store.state.app.me) return next();
    const me = await store.dispatch('fetchMe');
    if (!me) {
      localStorage.removeItem('token');
      http.defaults.headers.common.Authorization = '';
      return next('/login');
    }
    if (me.isAdmin) {
      // 관리자 토큰이 localStorage에 남아있을 경우, 관리자 토큰을 지우고 다시 로그인 시도
      localStorage.clear();
      http.defaults.headers.common.Authorization = '';
      return next('/login');
    }
    if (from.path === '/login') return next({ path: '/', replace: true });
    return next();
  };

  const checkAdminToken = async function beforeEnter(to, from, next) {
    if (!localStorage['admin-token']) {
      if (to.fullPath === '/admin/login') return next();
      return next({ path: '/admin/login', replace: true });
    }
    if (store.state.app.me) return next();
    const me = await store.dispatch('fetchMe');
    if (!me) {
      localStorage.removeItem('admin-token');
      http.defaults.headers.common.Authorization = '';
      return next('/admin/login');
    }
    if (from.path === '/admin/login') return next({ path: '/admin', replace: true });
    return next();
  };

  const config = {
    mode: 'history',
    routes: [
      { path: '/login', component: login, props: { title: '로그인' } },
      { path: '/register', component: register, props: { title: '회원가입' } },
      {
        path: '/',
        component: index,
        redirect: '/mylist',
        beforeEnter: checkToken,
        children: [
          { path: '/orders', component: orders, props: { title: '주문' } },
          { path: '/orders/sender', component: mobileOrdersSender, props: { title: '배송 및 결제정보' } },
          { path: '/mylist', component: mylist, props: { title: '나의 주문내역' } },
          { path: '/mylist/:orderId', component: mylistDetail, props: { title: '주문 상세보기' } },
          { path: '/complete/:orderId', component: complete, props: { title: '주문 완료' } },
        ],
      },
      {
        path: '/admin',
        component: admin,
        beforeEnter: checkAdminToken,
        redirect: '/admin/order',
        children: [
          { path: 'login', component: adminLogin },
          { path: 'order', component: adminOrder, props: { index: 1 } },
          { path: 'order/:orderId', component: adminOrderDetail, props: { index: 1 } },
          { path: 'member', component: adminMember, props: { index: 2 } },
          { path: 'members/:memberId', component: adminMemberDetail, props: { index: 2 } },
          { path: 'drug', component: adminDrug, props: { index: 3 } },
          { path: 'drug/add', component: adminDrugAdd, props: { index: 3 } },
          { path: 'drug/:drugId', component: adminDrugAdd, props: { index: 3 } },
          { path: 'recipe', component: adminRecipe, props: { index: 4 } },
          { path: 'recipe/add', component: adminRecipeManager, props: { index: 4 } },
          { path: 'recipe/:recipeId', component: adminRecipeManager, props: { index: 4 } },
        ],
      },
    ],
  };

  return new Router(config);
}



// WEBPACK FOOTER //
// ./src/router/index.js